
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"20","width":"20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.667 14.167v-12.5h12.5v9.166H5.062zM5.062 15v-2.417h10.855V5.021h2.416v13.312L15 15zm7.355-11.583h-9V10l.937-.917h8.063zm-9 0V10z","fill":"currentColor"}})])
          )
        }
      }
    